import { Component, Event, EventEmitter, getAssetPath, h, Host, Prop, State } from '@stencil/core';

import wcShared from '@web-components/shared';

import { SupportPremiumLevelId } from '../../../utils/enum';
import helpdeskCommon from '../../../utils/HelpdeskCommon.class';
import { InitStore } from '../../../utils/Stores/init-store';
import { Store } from '../../../utils/Stores/store';
import { isNullOrUndefined } from '../../../utils/utils';

@Component({
  tag: 'landing-module-component',
  styleUrl: 'landing-module.scss',
  shadow: true,
})
export class ModuleLanding {
  @Event() sectionChangeEvent: EventEmitter<IWCContextClose[]>;
  @Event() closeEvent: EventEmitter;

  @Prop() readonly firstName: string;
  @Prop() readonly chatbotEnabled: boolean = true;

  @State() copied = false;
  @State() progress = 0;
  @State() initStore: IWCInit;

  private supportLevel = Store?.get('supportPremium').supportLevel;
  private isLogged = Boolean(InitStore?.get('init')?.user?.id);
  private maxWaitingTime = 180;
  private loadingAccess = {
    workspace: false,
    kdrive: false,
    kchat: false,
  };

  componentWillLoad() {
    this.generateProgress();
    this.initStore = InitStore?.get('init');
  }

  private goToSection(section: IWCContextClose) {
    this.sectionChangeEvent.emit([section]);
  }

  private goToSupportPremiumSales() {
    const salesUrl = wcShared?.store?.productsRouting?.website + '/gtl/support-premium.premium';
    window.open(salesUrl, '_blank', 'noopener,noreferrer');
  }

  private goToSupportPremiumRenew() {
    const renewUrl =
      wcShared?.store?.productsRouting?.shop +
      '/order/support_premium/' +
      Store?.get('supportPremium').id;
    window.open(renewUrl, '_blank', 'noopener,noreferrer');
  }

  private goToPartnerContact() {
    const partnerContactUrl =
      wcShared?.store?.productsRouting?.manager + '/v3/ng/accounts/client-space/list';
    window.open(partnerContactUrl, '_blank', 'noopener,noreferrer');
  }

  private goToMeet() {
    window.open(this.initStore?.kmeet_support_access_url, '_blank', 'noopener,noreferrer');
  }

  private goToSupportDashboard() {
    window.open(
      wcShared?.store?.productsRouting?.manager + '/v3/ng/support-premium/dashboard',
      '_blank',
      'noopener,noreferrer',
    );
  }

  private close() {
    this.closeEvent.emit();
  }

  // private copyVipCode() {
  //   const TempText = document.createElement('input');
  //   TempText.value = Store?.get('supportPremium').vipCode;
  //   document.body.appendChild(TempText);
  //   TempText.select();
  //
  //   document.execCommand('copy');
  //   document.body.removeChild(TempText);
  //   this.copied = true;
  // }

  // private downloadProcedure() {
  //   return wcShared.httpCall(
  //     'GET',
  //     `/api/components/support/premium/${Store?.get('supportPremium').id}/download_procedure`,
  //   )
  //     .then((r) => r.blob())
  //     .then((blob) => {
  //       const aElement = document.createElement('a');
  //       aElement.setAttribute('download', `premium_procedure_${Store?.get('supportPremium').id}`);
  //       const href = URL.createObjectURL(blob);
  //       aElement.href = href;
  //       aElement.setAttribute('target', '_blank');
  //       aElement.click();
  //       URL.revokeObjectURL(href);
  //
  //       return blob;
  //     });
  // }

  private getSupportPremiumName() {
    switch (this.supportLevel) {
      case SupportPremiumLevelId.included:
        return wcShared?.translate('Support Classique');
      case SupportPremiumLevelId.plus:
        return wcShared?.translate('Support Plus');
      case SupportPremiumLevelId.pro:
        return wcShared?.translate('Support PRO');
      case SupportPremiumLevelId.business:
        return wcShared?.translate('Support Entreprise');
      default:
        return '';
    }
  }

  private generateProgress() {
    if (!Boolean(InitStore?.get('init')?.code?.next_refresh)) {
      return;
    }

    let chronometre = this.maxWaitingTime - InitStore?.get('init')?.code?.next_refresh;

    setInterval(() => {
      if (chronometre < this.maxWaitingTime) {
        chronometre++;
      } else {
        chronometre = 0;
        helpdeskCommon?.getInit();
      }
      this.progress = chronometre;
    }, 1000);
  }

  private authorizationChange(event, name) {
    if (this.loadingAccess[name]) {
      return;
    }

    this.loadingAccess[name] = true;

    if (event.target.checked) {
      wcShared.httpCall('POST', `/api/components/chatbot/support/${name}/access`).then(() => {
        this.loadingAccess[name] = false;
      });
    } else {
      wcShared.httpCall('DELETE', `/api/components/chatbot/support/${name}/access`).then(() => {
        this.loadingAccess[name] = false;
      });
    }
  }

  render() {
    const openTicketCount =
      this.initStore.tickets?.filter((ticket: SupportTicket) => ticket.status !== 'closed')
        .length || 0;
    const showTicketNotificationDot = this.initStore.tickets?.some(
      (ticket: SupportTicket) => ticket.status === 'waiting', // `waiting` means we are waiting an answer from the customer
    );

    return (
      <Host>
        <div class={{ 'overflow--hidden': !Store?.get('is_full') }}>
          {this.isLogged && <light-header-component></light-header-component>}
          <div class={{ layout: !Store?.get('is_full'), 'is-logged': this.isLogged }}>
            <div
              class={{
                landing: true,
                'background-pro': this.supportLevel === SupportPremiumLevelId.pro,
                'background-business': this.supportLevel === SupportPremiumLevelId.business,
                full: Store?.get('is_full'),
              }}
            >
              {Store?.get('is_full') ? (
                <div class="header-full-container__title">
                  {wcShared?.translate('Support infomaniak')}
                </div>
              ) : Store?.get('is_report_abuse') ? (
                <div class="header-full-container__title">
                  {' '}
                  {wcShared?.translate('Signaler un abus')}
                </div>
              ) : (
                <div>
                  <div
                    class={{
                      'landing__title-account': true,
                      hide: !Boolean(this.initStore?.user?.id),
                    }}
                  >
                    {wcShared.translate('Organisation')}{' '}
                    <span>{this.initStore?.user?.account?.organization_name}</span>
                  </div>
                  <div class="landing__title">
                    {wcShared.translate('Bonjour')} {this.firstName} ! 👋
                  </div>
                  <div class="landing__subtitle">
                    {this.supportLevel ? (
                      <span
                        class="current-premium-support"
                        innerHTML={wcShared.translate(
                          'Vous beneficiez du <strong>$product$</strong>.',
                          { product: this.getSupportPremiumName() },
                        )}
                      >
                        &nbsp;
                        <span
                          onClick={() => this.goToSupportPremiumRenew()}
                          class={{
                            hide: ![SupportPremiumLevelId.plus, SupportPremiumLevelId.pro].includes(
                              this.supportLevel,
                            ),
                          }}
                        >
                          {wcShared.translate("Changer d'offre de Support")}
                        </span>
                        <span
                          onClick={() => this.goToSupportPremiumSales()}
                          class={{ hide: this.supportLevel !== SupportPremiumLevelId.included }}
                        >
                          {wcShared.translate('Souscrire au Support Premium')}
                        </span>
                      </span>
                    ) : (
                      wcShared.translate('Un soucis, une question, un doute ?')
                    )}
                  </div>
                  <div
                    // eslint-disable-next-line @typescript-eslint/naming-convention
                    class={{ header__close: true, hide: window['CHATBOT_FULL'] || this.isLogged }}
                    data-e2e="wc-helpdesk-header__close"
                    onClick={() => {
                      this.close();
                    }}
                  >
                    <img
                      src={getAssetPath('./../assets/icons/white-cross.svg')}
                      alt={wcShared.translate('Fermer')}
                    />
                  </div>
                </div>
              )}
              {Store?.get('is_report_abuse') ? (
                <div>
                  <report-abuse-module-component>
                    <div slot="recaptcha-slot-4">
                      <slot name="recaptcha-slot-3" />
                    </div>
                  </report-abuse-module-component>
                </div>
              ) : (
                <div>
                  <div
                    class={{
                      'landing__card flex-row clickable': true,
                      disabled: !this.chatbotEnabled,
                      hide: openTicketCount === 0,
                    }}
                    onClick={() => (this.chatbotEnabled ? this.goToSection('tickets') : null)}
                  >
                    <div>
                      <div class="landing__card--header">
                        <img
                          class="landing__card--header-icon"
                          src={getAssetPath('./../assets/rounded-icons/icon-tag.svg')}
                          alt={wcShared?.translate('tickets')}
                        />
                        <div class="landing__card--title">
                          {wcShared?.translate('Consulter mes tickets')}
                          {showTicketNotificationDot ? (
                            <span class="notification-dot"></span>
                          ) : null}
                        </div>
                      </div>
                      <div class="landing__card--description">
                        <span class="accent">{`${openTicketCount} `}</span>
                        {openTicketCount < 2
                          ? wcShared.translate('ticket ouvert')
                          : wcShared.translate('tickets ouverts')}
                        .
                      </div>
                    </div>
                    <img
                      class="right arrow-icon"
                      src={getAssetPath('./../assets/icons/arrow-right.svg')}
                      alt={wcShared?.translate('Acceder')}
                    />
                  </div>

                  <div class="landing__card">
                    <div class="landing__card--header">
                      <img
                        class="landing__card--header-icon"
                        src={getAssetPath('./../assets/rounded-icons/icon-book.svg')}
                        alt={wcShared?.translate('Aide')}
                      />
                      <div class="landing__card--title">
                        {wcShared.translate('Rechercher dans laide')}
                      </div>
                      <button
                        class="blue-link see-help right"
                        onClick={() => this.goToSection('faq_list')}
                      >
                        {wcShared.translate('Voir toutes les aides')}
                      </button>
                    </div>
                    <faq-landing-module></faq-landing-module>
                  </div>
                  <div class={{ 'alert-incident': true, hide: this.chatbotEnabled }}>
                    <div class="alert-incident--left">
                      <div class="alert-incident__icon">
                        <img
                          src={getAssetPath('./../assets/icons/warning.svg')}
                          alt={wcShared?.translate('Attention')}
                        />
                      </div>
                      <div class="alert-incident__text">
                        {wcShared.translate(
                          'Une operation de maintenance est en cours. Le support sera a nouveau disponible dans le courant de la soiree.',
                        )}
                      </div>
                    </div>
                  </div>

                  <div
                    class={{
                      'landing__card flex-row clickable': true,
                      hide: !Store?.get('isInPartnership'),
                    }}
                    onClick={() => this.goToPartnerContact()}
                  >
                    <div>
                      <div class="landing__card--header">
                        <img
                          class="landing__card--header-icon"
                          src={getAssetPath('./../assets/rounded-icons/icon-partner.svg')}
                          alt={wcShared?.translate('Support')}
                        />
                        <div class="landing__card--title">
                          {wcShared.translate("J'ai un partenaire Infomaniak")}
                        </div>
                      </div>
                      <div class="landing__card--description">
                        {wcShared.translate(
                          'Vous avez un partenaire IT qui gère vos produits ou votre site ? Adressez directement vos demandes à votre partenaire.',
                        )}
                      </div>
                    </div>
                    <img
                      class="right arrow-icon"
                      src={getAssetPath('./../assets/icons/arrow-right.svg')}
                      alt={wcShared?.translate('Acceder')}
                    />
                  </div>

                  <div
                    class={{
                      'landing__card flex-row clickable': true,
                      disabled: !this.chatbotEnabled,
                    }}
                    onClick={() => (this.chatbotEnabled ? this.goToSection('chat') : null)}
                  >
                    <div>
                      <div class="landing__card--header">
                        <img
                          class="landing__card--header-icon"
                          src={getAssetPath('./../assets/rounded-icons/icon-headset.svg')}
                          alt={wcShared?.translate('Support')}
                        />
                        <div class="landing__card--title">
                          {wcShared.translate('Je souhaite contacter le support')}
                        </div>
                      </div>
                      <div class="landing__card--description">
                        {wcShared.translate(
                          'Discutez avec notre chatbot ou joignez nos equipes par mail, chat ou telephone',
                        )}
                        .
                      </div>
                    </div>
                    <img
                      class="right arrow-icon"
                      src={getAssetPath('./../assets/icons/arrow-right.svg')}
                      alt={wcShared?.translate('Acceder')}
                    />
                  </div>

                  {this.supportLevel === SupportPremiumLevelId.included && (
                    <div
                      class="landing__card flex-row clickable"
                      onClick={() => this.goToSupportPremiumSales()}
                    >
                      <div>
                        <div class="landing__card--header">
                          <img
                            class="landing__card--header-icon"
                            src={getAssetPath('./../assets/icons/support-premium/1.svg')}
                            alt="support-premium"
                          />
                          <div class="landing__card--title">
                            {wcShared.translate('Support Premium')}
                          </div>
                        </div>
                        <div class="landing__card--description">
                          {wcShared.translate(
                            'Donnez la priorite a vos demandes de support en souscrivant au Support Premium',
                          )}
                          .
                        </div>
                      </div>
                      <img
                        class="right arrow-icon"
                        src={getAssetPath('./../assets/icons/arrow-right.svg')}
                        alt={wcShared?.translate('Acceder')}
                      />
                    </div>
                  )}
                  {/* Support Premium Plus block
                  {this.supportLevel === SupportPremiumLevelId.plus &&
                    <div>
                      <div class="landing__card flex-row">
                        <div>
                          <div class="landing__card--header">
                            <img class="landing__card--header-icon"
                                 src={getAssetPath('./../assets/rounded-icons/icon-headset-yellow.svg')}
                                 alt={wcShared?.translate('Support')}/>
                            <div class="landing__card--title">{wcShared.translate("Votre code VIP")} : {Store?.get('supportPremium').vipCode}</div>
                          </div>
                        </div>

                        {
                          this.copied ?
                            <img
                              class="right arrow-icon clickable check"
                              src={getAssetPath('./../assets/icons/copy-success.svg')}
                              alt={wcShared.translate("Copie")}/>
                          :
                            <img
                              class="right arrow-icon clickable"
                              src={getAssetPath('./../assets/icons/copy-primary.svg')}
                              alt={wcShared.translate("Copie")}
                              onClick={() => this.copyVipCode()}/>
                        }
                      </div>

                      <div class="landing__card flex-row">
                        <div>
                          <div class="landing__card--header">
                            <img class="landing__card--header-icon"
                            src={getAssetPath('./../assets/icons/document.svg')}
                            alt={wcShared?.translate('Support')}/>
                            <div class="landing__card--title">{wcShared.translate("Procedure de panne")}</div>
                          </div>
                        </div>
                        <img
                          class="right arrow-icon clickable"
                          src={getAssetPath('./../assets/icons/download.svg')}
                          alt={wcShared?.translate('Acceder')}
                          onClick={() => this.downloadProcedure()}/>
                      </div>
                    </div>
                  }
                  */}

                  {[SupportPremiumLevelId.pro, SupportPremiumLevelId.business].includes(
                    this.supportLevel,
                  ) && (
                    <div>
                      <div
                        class="landing__card flex-row clickable"
                        onClick={() => this.goToSection('contact_mail')}
                      >
                        <div>
                          <div class="landing__card--header">
                            <img
                              class="landing__card--header-icon"
                              src={getAssetPath('./../assets/rounded-icons/icon-mail-yellow.svg')}
                              alt={wcShared?.translate('Icon mail')}
                            />
                            <div class="landing__card--title">
                              {wcShared.translate('Ticket prioritaire')}
                            </div>
                          </div>
                        </div>
                        <img
                          class="right arrow-icon"
                          src={getAssetPath('./../assets/icons/arrow-right.svg')}
                          alt={wcShared?.translate('Acceder')}
                        />
                      </div>

                      <div
                        class="landing__card flex-row clickable"
                        onClick={() => this.goToSection('contact_phone')}
                      >
                        <div>
                          <div class="landing__card--header">
                            <img
                              class="landing__card--header-icon"
                              src={getAssetPath(
                                './../assets/rounded-icons/icon-headset-yellow.svg',
                              )}
                              alt={wcShared?.translate('Support')}
                            />
                            <div class="landing__card--title">
                              {wcShared.translate('Appel prioritaire')}
                            </div>
                          </div>
                        </div>
                        <img
                          class="right arrow-icon"
                          src={getAssetPath('./../assets/icons/arrow-right.svg')}
                          alt={wcShared?.translate('Acceder')}
                        />
                      </div>

                      <div
                        class="landing__card flex-row clickable"
                        onClick={() => this.goToSection('technical_emergency')}
                      >
                        <div>
                          <div class="landing__card--header">
                            <img
                              class="landing__card--header-icon"
                              src={getAssetPath('./../assets/rounded-icons/icon-urgence.svg')}
                              alt={wcShared?.translate('Icon warning')}
                            />
                            <div class="landing__card--title">
                              {wcShared.translate('Urgence technique critique')}
                            </div>
                          </div>
                        </div>
                        <img
                          class="right arrow-icon"
                          src={getAssetPath('./../assets/icons/arrow-right.svg')}
                          alt={wcShared?.translate('Acceder')}
                        />
                      </div>
                    </div>
                  )}

                  {!isNullOrUndefined(this.initStore?.user?.id) &&
                    this.supportLevel !== SupportPremiumLevelId.included && (
                      <div
                        class="landing__card flex-row clickable"
                        onClick={() => this.goToSupportDashboard()}
                      >
                        <div>
                          <div class="landing__card--header">
                            <img
                              class="landing__card--header-icon"
                              src={getAssetPath(
                                `./../assets/icons/support-premium/${this.supportLevel}.svg`,
                              )}
                              alt="icon-support"
                            />
                            <div class="landing__card--title">{this.getSupportPremiumName()}</div>
                          </div>
                          <div class="landing__card--description">
                            {wcShared.translate('Tableau de bord')}.
                          </div>
                        </div>
                        <img
                          class="right arrow-icon"
                          src={getAssetPath('./../assets/icons/arrow-right.svg')}
                          alt={wcShared?.translate('Acceder')}
                        />
                      </div>
                    )}

                  <div
                    class={{
                      'landing__card support-access': true,
                      hide: isNullOrUndefined(this.initStore?.user?.id),
                    }}
                  >
                    <div class="support-access__header">
                      <img
                        class="landing__card--header-icon"
                        src={getAssetPath('./../assets/icons/support-code.svg')}
                        alt="code support"
                      />
                      <div class="landing__card--title">
                        {wcShared.translate("Autorisations d'accès")}
                      </div>
                      <div class="tooltip">
                        <img
                          src={getAssetPath('./../assets/icons/information-circle.svg')}
                          alt={wcShared.translate('Icon information')}
                        />
                        <span class="tooltiptext">
                          {wcShared?.translate(
                            "L'autorisation est valable 7 jours et peut etre retiree a tout moment.",
                          )}
                        </span>
                      </div>
                    </div>
                    <div class="support-access__line first-line">
                      {wcShared.translate("Code d'autorisation a communiquer au support")}
                      <span class="code">
                        {InitStore?.get('init')?.code?.code}
                        <module-progress-spinner-component
                          stroke={2}
                          radius={14}
                          progress={this.progress}
                        ></module-progress-spinner-component>
                      </span>
                    </div>

                    <div class="support-access__line">
                      {wcShared.translate("Autoriser l'acces au support a Mail, Calendar, Contact")}
                      <div class="switch">
                        <input
                          type="checkbox"
                          id="workspace"
                          checked={this.initStore?.support?.workspace_access}
                          onChange={(event) => this.authorizationChange(event, 'workspace')}
                        />
                        <label htmlFor="workspace"></label>
                      </div>
                    </div>

                    {this.initStore?.support?.drive_access !== null && (
                      <div class="support-access__line">
                        {wcShared.translate("Autoriser l'acces au support a kDrive")}
                        <div class="switch">
                          <input
                            type="checkbox"
                            id="kdrive"
                            checked={this.initStore?.support?.drive_access}
                            onChange={(event) => this.authorizationChange(event, 'kdrive')}
                          />
                          <label htmlFor="kdrive"></label>
                        </div>
                      </div>
                    )}
                    {this.initStore?.support?.kchat_access !== null && (
                      <div class="support-access__line">
                        {wcShared.translate("Autoriser l'acces au support a kChat")}
                        <div class="switch">
                          <input
                            type="checkbox"
                            id="kchat"
                            checked={this.initStore?.support?.kchat_access}
                            onChange={(event) => this.authorizationChange(event, 'kchat')}
                          />
                          <label htmlFor="kchat"></label>
                        </div>
                      </div>
                    )}

                    {this.initStore?.kmeet_support_access_url && (
                      <button
                        class="kmeet-button"
                        onClick={() => this.goToMeet()}
                      >
                        <span class="bg-icon">
                          <img
                            src={getAssetPath('./../assets/icons/kmeet.svg')}
                            alt={wcShared.translate('Icon information')}
                          />
                        </span>
                        {wcShared.translate('Demarrer la reunion')}
                      </button>
                    )}
                  </div>

                  <div
                    class={{
                      'landing__card flex-row clickable': true,
                      hide: !Store?.get('is_full'),
                    }}
                    onClick={() => this.goToSection('contact_reception')}
                  >
                    <div>
                      <div class="landing__card--header">
                        <img
                          class="landing__card--header-icon"
                          src={getAssetPath('./../assets/rounded-icons/icon-reception.svg')}
                          alt={wcShared?.translate('Support')}
                        />
                        <div class="landing__card--title">
                          {wcShared.translate("Je suis un fournisseur d'Infomaniak")}
                        </div>
                      </div>
                      <div class="landing__card--description">
                        {wcShared.translate(
                          "Vous êtes un prestataire/fournisseur d'Infomaniak ? Contactez notre réception",
                        )}
                        .
                      </div>
                    </div>
                    <img
                      class="right arrow-icon"
                      src={getAssetPath('./../assets/icons/arrow-right.svg')}
                      alt={wcShared?.translate('Acceder')}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </Host>
    );
  }
}
